import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import Action from '../../Action';
import Loader from '../../Atoms/Loader';

import * as style from './style.module.css';

const parseHint = (nb) => (nb > 99 ? '99+' : `${nb}`);

const Button = ({ label = '', title = '', loading = false, icon = null, iconOnlyOnMobile = false, active = false, disabled = false, className = '', theme = 'PRIMARY', size = 'MEDIUM', hint = 0, action = null, ...props }) => {
  const parsedLabel = `${label}`.trim();
  return (
    <Action
      action={disabled || loading ? null : action}
      title={parsedLabel || title}
      className={`${style.button} ${active ? style.active : ''} ${iconOnlyOnMobile ? style.iconOnlyOnMobile : ''} ${style[theme.toLowerCase()]} ${loading ? style.loading : ''} ${style[size.toLowerCase()]} ${disabled ? style.disabled : ''} ${
        parsedLabel ? style.text : ''
      } ${className}`}
      {...props}
    >
      {icon && <FontAwesomeIcon className={style.icon} icon={icon} />}
      {loading && <Loader className={style.loader} />}
      <span className={style.text}>{parsedLabel}</span>
      {hint > 0 && <div className={style.hint}>{parseHint(hint)}</div>}
    </Action>
  );
};

export default React.memo(Button);
